import {COLLECTION_EXAM_MODULE} from './constants';

export function getExamModuleCollectionPath(): string {
  return COLLECTION_EXAM_MODULE;
}
